import {Injectable} from '@angular/core';
import {
    disallowSpecialCharacters, emailValidation, frontendRequiredTrue,
    frontendRequiredValidator,
    fullDateValidation, requiredLengthExceptInputmask,
    requiredWithMessage
} from '@helpers/validators/frontendRequired';

@Injectable()
export class WizardValidators {
    /**
     * Поле обязательно к заполнению
     * @param name
     * @param useTemplate
     */
    static required(name?: string, useTemplate = true) {
        if (name) {
            /**
             * Либо шаблон, либо кастомную строку
             */
            const message = useTemplate ?
                `${name} фигурирует в пакете документов, поэтому это поле обязательное. Заполните и попробуйте снова.` :
                name;

            return requiredWithMessage(message);
        } else {
            return frontendRequiredValidator;
        }
    }

    static requiredTrue() {
        return frontendRequiredTrue;
    }

    /**
     * Поле должно быть заданной длины и без символов маски ввода
     * @param length
     * @param name
     */
    static requiredLength(length: number, name: string) {
        return requiredLengthExceptInputmask(length, this.getLengthRequiredMessage(length, name));
    }

    /**
     * Специальные символы, вроде %$# запрещены
     * @param name
     */
    static withoutSymbols(name: string) {
        return disallowSpecialCharacters(`в ${name} недопустимы, уберите их и попробуйте снова.`);
    }

    /**
     * Валидация даты
     */
    static date() {
        return fullDateValidation();
    }

    /**
     * Валидация электронной почты
     */
    static email() {
        return emailValidation;
    }

    /**
     * Валидация почтового индекса
     */
    static index() {
        return [
            this.required('Индекс'),
            this.requiredLength(6, 'Индекс'),
        ];
    }

    static getLengthRequiredMessage(length: number, name: string): string {
        return `${name} состоит из ${length} цифр, перепроверьте введеные данные и попробуйте снова.`;
    }
}
